var render = function render(){var _vm=this,_c=_vm._self._c;return _c('excel-export',{staticClass:"w-100",attrs:{"data":_vm.processedItems,"fields":_vm.excelFields,"worksheet":"Denuncias Karin","name":"denuncias_karin.xlsx"}})
}
var staticRenderFns = []

export { render, staticRenderFns }